<form [formGroup]="form">
    <div class="grid flex flex-column col-12 md:col-12">
        <h3 class="primary-color pb-2">Por favor confirma tus datos para continuar</h3>
        <span>¿Tu información está correcta?</span>
    </div>
    <div class="grid">
        <div class="col-12 flex flex-column">
            <span><b>Nombre: </b><br />&nbsp;&nbsp;{{ nombreCompleto | titlecase }}</span>
            <!-- <span><b>Tipo de identificación: </b><br>&nbsp;&nbsp;{{ tipoDocumento | titlecase}}</span> -->
            <span><b>Identificación: </b><br />&nbsp;&nbsp;{{ ofuscarIdentificacion(dataCandidate?.candidateInfo?.identificacion) }}</span>
        </div>
    </div>

    <!-- <div class="justify-content-center gap-2 mt-4 flex">
    <button miButton="danger" [miButtonIcon]="'solar:backspace-broken'" type="button" (click)="setMode('FIX')">No, corregir</button>
    <button miButton="primary" [miButtonIcon]="'solar:verified-check-broken'" type="button" (click)="setMode('OK')">
      Sí, está correcta
    </button>
  </div> -->

    <!-- Sección visible sólo cuando el modo es 'OK' -->
    @if (form.get('mode')?.value === 'OK') {
    <div miForm class="grid mt-4 justify-content-center" [formGroup]="acceptGroup">
        <!-- Contenedor en columna, centrado -->
        <div class="col-12 flex flex-column align-items-center">
            <span class="mb-2 text-center">Por favor confirma tu identificación para continuar</span>

            <div
                [miCol]="12"
                miFormField
                miForm
                [miFormFieldError]="getErrorMessage('tipoDoc', 'El tipo de documento es requerido','accept')"
            >
                <label>Tipo de documento *</label>
                <p-select
                    formControlName="tipoDoc"
                    [options]="identificationList"
                    [filter]="true"
                    [filterBy]="'label,id'"
                    optionLabel="label"
                    optionValue="id"
                    placeholder="Tipo de documento"
                    appendTo="body"
                ></p-select>
            </div>

            <!-- Ancho del field controlado, centrado -->
            <div [miCol]="12" miFormField miForm [miFormFieldError]="getErrorMessage('codEmp', 'La identificación es requerida','accept')">
                <label>Identificación *</label>
                <input
                    pInputText
                    soloNumeros
                    formControlName="codEmp"
                    placeholder="Ingrese identificación"
                    (copy)="onBlockEvent($event)"
                    (paste)="onBlockEvent($event)"
                />
            </div>
        </div>
    </div>
    }

    <!-- Modo: Corrección (solo visible cuando FIX) -->
    @if (form.get('mode')?.value === 'FIX') {
    <div miForm class="grid mt-4" [formGroup]="correctionGroup">
        <!-- Tipo de documento (primero) -->
        <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('tipoDoc1', 'El tipo de documento es requerido', 'correction')">
            <label>Tipo de documento *</label>
            <p-select
                formControlName="tipoDoc1"
                [options]="identificationList"
                [filter]="true"
                [filterBy]="'label,id'"
                optionLabel="label"
                optionValue="id"
                placeholder="Tipo de documento"
                appendTo="body"
            ></p-select>
        </div>

        <!-- Número de documento (primero) -->
        <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('docNum1', 'El número de documento es requerido', 'correction')">
            <label>Número de documento *</label>
            <input
                pInputText
                soloNumeros
                formControlName="docNum1"
                placeholder="Número de documento"
                (copy)="onBlockEvent($event)"
                (paste)="onBlockEvent($event)"
            />
            <!-- Mensaje específico de patrón, si lo deseas -->
            @if (correctionGroup.get('docNum1')?.hasError('pattern') && (correctionGroup.get('docNum1')?.touched ||
            correctionGroup.get('docNum1')?.dirty)) {
            <small class="text-red-500"> Formato inválido (usa letras, números, '.', '-'; 4 a 20 caracteres). </small>
            }
        </div>

        <!-- Tipo de documento (confirmación) -->
        <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('tipoDoc2', 'Confirma el tipo de documento', 'correction')">
            <label>Confirma el tipo de documento *</label>
            <p-select
                formControlName="tipoDoc2"
                [options]="identificationList"
                optionLabel="label"
                optionValue="id"
                placeholder="Confirma el tipo de documento"
                appendTo="body"
            ></p-select>

            <!-- Error de no coincidencia para tipo de documento -->
            @if (correctionGroup.hasError('tipoDocMustMatch') && (correctionGroup.get('tipoDoc2')?.touched ||
            correctionGroup.get('tipoDoc2')?.dirty)) {
            <span class="text-red-500"> Los tipos de documento no coinciden. </span>
            }
        </div>

        <!-- Número de documento (confirmación) -->
        <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('docNum2', 'El número de documento es requerido', 'correction')">
            <label>Confirma el número de documento *</label>
            <input
                pInputText
                soloNumeros
                formControlName="docNum2"
                placeholder="Confirma el número de documento"
                (copy)="onBlockEvent($event)"
                (paste)="onBlockEvent($event)"
            />

            <!-- Error de no coincidencia para número de documento -->
            @if (correctionGroup.hasError('docNumMustMatch') && (correctionGroup.get('docNum2')?.touched ||
            correctionGroup.get('docNum2')?.dirty)) {
            <span class="text-red-500"> Los números de documento no coinciden. </span>
            }
        </div>
    </div>
    }

    <!-- Botón -->
    <div
        class="flex flex-column mt-2 gap-4 w-full align-items-center"
    >
        @if (showFixOption() && form.get('mode')?.value === 'OK') {
        <span class="text-blue-500 cursor-pointer" (click)="setMode('FIX')">Quiero corregir mi identificación</span>
        }
        <div class="flex justify-content-end w-full">
            <button miButton="save" [disabled]="!form.valid" type="button" (click)="onSubmit()">Continuar</button>
        </div>
    </div>
</form>
